/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs */

const en_directory_comparison_product_hunt_rows_navigation_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by fit, platform, and category`)
};

const zh_directory_comparison_product_hunt_rows_navigation_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按匹配度、平台和分类浏览`)
};

/**
* | output |
* | --- |
* | "Browse by fit, platform, and category" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_navigation_left = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Navigation_LeftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_navigation_left(inputs)
	return zh_directory_comparison_product_hunt_rows_navigation_left(inputs)
});
export { directory_comparison_product_hunt_rows_navigation_left as "directory.comparison.product_hunt.rows.navigation.left" }